import { useEffect, useState } from "react";
import { api, formatTL } from "@/lib/api";

export default function Customers() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/customers").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <h1 className="text-2xl font-extrabold text-white mb-6">Müşteriler <span className="text-sm text-gray-400 font-normal">({rows.length})</span></h1>
      <div className="card-surface overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-gray-400 text-left border-b border-white/10">{["Ad Soyad", "E-posta", "Sipariş", "Harcama", "Son Sipariş"].map((h) => <th key={h} className="px-4 py-3 font-medium">{h}</th>)}</tr></thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.email} className="border-b border-white/5 hover:bg-white/5">
                <td className="px-4 py-3 text-white">{c.name}</td>
                <td className="px-4 py-3 text-gray-300">{c.email}</td>
                <td className="px-4 py-3 text-gray-400">{c.orders}</td>
                <td className="px-4 py-3 text-white">{formatTL(c.spent)}</td>
                <td className="px-4 py-3 text-gray-400 text-xs">{(c.last_order || "").slice(0, 10)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-gray-500">Henüz müşteri yok</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
